import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { useActiveColorScheme } from "@m/alchemy-theme";
import * as Styled from "./Tabs.styled";
import { Tab } from "./Tab";
export const Tabs = forwardRef((props, ref) => {
    const { activeTabValue, children, defaultTabValue, layout, onTabClick, tabs, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, 
    // TODO add aria-orientation if we add support for vertical tabs layout
    ...otherProps } = props;
    const [activeTab, setActiveTab] = useState(activeTabValue || defaultTabValue);
    const handleClick = (event, item) => {
        if (!event.ctrlKey && !event.metaKey && item.href === undefined) {
            event.preventDefault();
        }
        // If tabs are a link they won't have clickedTabValue
        if (!activeTabValue && item.value !== undefined) {
            setActiveTab(item.value);
        }
        onTabClick && onTabClick(event, item);
    };
    const currentActiveTab = activeTabValue ? activeTabValue : activeTab;
    const activeColorScheme = useActiveColorScheme();
    return (_jsx(Styled.TabWrapper, { ref: ref, "data-testid": "Tabs", palette: "interactiveConstructive", activeColorScheme: activeColorScheme, ...otherProps, children: _jsx(Styled.TabFocusList, { layout: layout, role: "tablist", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, itemSelector: "button", keyboardDirection: "horizontal", children: tabs
                ? tabs.map(({ onClick, ...item }) => (_jsx(Tab, { layout: layout, onClick: (event) => {
                        onClick && onClick(event, item);
                        handleClick(event, item);
                    }, isActive: item.value === currentActiveTab, ...item }, item.value)))
                : children }) }));
});
Tabs.displayName = "Tabs";
